<style>
@media only screen and (max-width: 850px) {
  .news-content {
    height: 5.692rem !important;
  }
}
</style>
<template>
  <!-- Featured Plans -->
  <!-- /Featured Plans -->

  <!-- Latest News -->
  <section class="section featured-venues latest-news">
    <div class="container">
      <div class="section-heading aos" data-aos="fade-up">
        <h2><span>Tin tức</span> mới nhất</h2>
        <p class="sub-title">
          Cập nhật những tin tức mới nhất từ thế giới cầu lông – luôn nắm bắt
          thông tin và truyền cảm hứng từ những thành tích ấn tượng và khoảnh
          khắc đầy kịch tính trong môn thể thao này.
        </p>
      </div>
      <div class="row">
        <div class="featured-slider-group">
          <div class="owl-carousel featured-venues-slider owl-theme">
            <!-- News -->
            <Carousel
                :breakpoints="breakpoints"
                :settings="settings"
                :wrap-around="true"
            >
              <Slide v-for="item in data" :key="item.id">
                <div class="featured-venues-item aos" data-aos="fade-up">
                  <div class="listing-item mb-0">
                    <div class="listing-img">
                      <router-link :to="`/tic-tuc/${item?.slug}`">
                        <img
                            :src="
                            item?.media?.url
                              ? `${url + item.media.url}`
                              : require('@/assets/img/bg/login_bg.jpg')
                          "
                            alt="User"
                        />
                      </router-link>
                      <div class="fav-item-venues news-sports">
                        <span class="tag tag-blue">{{
                            item?.news_category?.name
                          }}</span>
                      </div>
                    </div>
                    <div class="listing-content news-content text-start">
                      <h3 class="listing-title mb-0">
                        <router-link :to="`/tic-tuc/${item?.slug}`">{{
                            item.title
                          }}
                        </router-link>
                      </h3>
                    </div>
                  </div>
                </div>
              </Slide>
              <template #addons>
                <Navigation/>
              </template>
            </Carousel>
            <!-- /News -->
          </div>
        </div>
      </div>

      <!-- View More -->
      <div class="view-all text-center aos" data-aos="fade-up">
        <router-link
            class="btn btn-secondary d-inline-flex align-items-center"
            to="/tin-tuc"
        >Xem thêm
          <span class="lh-1"
          ><i class="feather-arrow-right-circle ms-2"></i></span
          ></router-link>
      </div>
      <!-- View More -->
    </div>
  </section>
  <!-- /Latest News -->
</template>

<script>
import {Carousel, Navigation, Pagination, Slide} from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import {GET_NEWS} from "@/graphql/operations/news.ts";
import {useQuery} from "@vue/apollo-composable";
import {ref, watch} from "vue";

export default {
  data() {
    const url = process.env.VUE_APP_SERVER_URL;
    const {result: news} = useQuery(GET_NEWS, () => ({
      slug: "",
    }));
    const data = ref([]);

    watch(
        news,
        () => {
          if (news.value && news.value.news) {
            data.value = news.value.news.sort((a, b) => {
              return (
                  new Date(b.publish_start_date) - new Date(a.publish_start_date)
              );
            });
          }
        },
        {deep: true}
    );
    return {
      data,
      url,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        575: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        767: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        991: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Navigation,
    Pagination,
  },
  methods: {
    toggleSelected(item) {
      item.isSelected = !item.isSelected;
    },
    formatDate(dateString) {
      if (!dateString) return "";
      return new Date(dateString).toLocaleDateString("vi-VN");
    },
  },
};
</script>
